import AssetConfig from './AssetConfig';
import ShowcaseConfig from './ShowcaseConfig';

export default class BannerConfig extends AssetConfig {
  public timetravel(): boolean {
    return !!super.get('timetravel');
  }

  public showcase(): ShowcaseConfig | undefined {
    if (!this.has('showcase')) {
      return;
    }

    return new ShowcaseConfig(this.get('showcase'));
  }
}
